import { ANALYTICS_KPI_URL, ANALYTICS_KPI_TITLES_URL, ANALYTICS_BASE_URL, API_PDC_URL_V1 } from "../../../config";
import axios from "axios";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const analyticsConstants = {
  GET_KPI_LIST_START: "GET_KPI_LIST_START",
  GET_KPI_LIST_SUCCESS: "GET_KPI_LIST_SUCCESS",
  GET_KPI_LIST_ERROR: "GET_KPI_LIST_ERROR",

  GET_KPI_TITLE_START: "GET_KPI_TITLE_START",
  GET_KPI_TITLE_SUCCESS: "GET_KPI_TITLE_SUCCESS",
  GET_KPI_TITLE_ERROR: "GET_KPI_TITLE_ERROR",

  GET_CREDITS_START: "GET_CREDITS_START",
  GET_CREDITS_SUCCESS: "GET_CREDITS_SUCCESS",
  GET_CREDITS_ERROR: "GET_CREDITS_ERROR",

  GET_REVENUES_START: "GET_REVENUES_START",
  GET_REVENUES_SUCCESS: "GET_REVENUES_SUCCESS",
  GET_REVENUES_ERROR: "GET_REVENUES_SUCCESS",

  GET_OBLIGATIONS_START: "GET_OBLIGATIONS_START",
  GET_OBLIGATIONS_SUCCESS: "GET_OBLIGATIONS_SUCCESS",
  GET_OBLIGATIONS_ERROR: "GET_OBLIGATIONS_ERROR",

  GET_BP_ACTIVE_START: "GET_BP_ACTIVE_START",
  GET_BP_ACTIVE_SUCCESS: "GET_BP_ACTIVE_SUCCESS",
  GET_BP_ACTIVE_ERROR: "GET_BP_ACTIVE_ERROR"
};

export function getKpiTitles() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.companyUuidSelected;
    const accountantId = getState().main.accountantUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantId,
      "Accept-Language": user?.profile?.language || "it-IT"
    };
    let request = {
      method: "get",
      url: ANALYTICS_KPI_TITLES_URL + "?itemId=" + companyId,

      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_KPI_TITLE_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_KPI_TITLE_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_KPI_TITLE_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_KPI_TITLE_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function getKpiList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.clientIdSelected;
    const accountantId = getState().main.accountantIdSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantId,
      "Accept-Language": user?.profile?.language || "it-IT"
    };
    let request = {
      method: "get",
      url: ANALYTICS_KPI_URL + "?itemId=" + companyId,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_KPI_LIST_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_KPI_LIST_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_KPI_LIST_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })

        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_KPI_LIST_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function getCredits() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.clientIdSelected;

    const additionalHeaders = {
      "Accept-Language": user?.profile?.language || "it-IT"
    };

    let request = {
      method: "get",
      url: ANALYTICS_BASE_URL + "/CreditiStudio/" + companyId,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_CREDITS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_CREDITS_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_CREDITS_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_CREDITS_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function getRevenues() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.clientIdSelected;

    const additionalHeaders = {
      "Accept-Language": user?.profile?.language || "it-IT"
    };

    let request = {
      method: "get",
      url: ANALYTICS_BASE_URL + "/RicaviStudio/" + companyId,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_REVENUES_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_REVENUES_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_REVENUES_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_REVENUES_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function getObligations() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.clientIdSelected;

    const additionalHeaders = {
      "Accept-Language": user?.profile?.language || "it-IT"
    };

    let request = {
      method: "get",
      url: ANALYTICS_BASE_URL + "/AdempimentiRiepilogoTotale/" + companyId,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_OBLIGATIONS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_OBLIGATIONS_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_OBLIGATIONS_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_OBLIGATIONS_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function isBusinessPerformanceActive() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const companyId = getState().main.clientIdSelected;

    const additionalHeaders = {
      "Accept-Language": user?.profile?.language || "it-IT"
    };

    let request = {
      method: "get",
      url: ANALYTICS_BASE_URL + "/isBusinessPerformanceActive/" + companyId,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: analyticsConstants.GET_BP_ACTIVE_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: analyticsConstants.GET_BP_ACTIVE_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: analyticsConstants.GET_BP_ACTIVE_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: analyticsConstants.GET_BP_ACTIVE_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function sessionStart(companyId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;
    const accountantId = getState().main.accountantUuidSelected;
    const requester = getState().main.myType === "STUDIO" ? "Accountant" : "Customer";

    const additionalHeaders = {
      "Accept-Language": user?.profile?.language || "it-IT"
    };

    let request = {
      method: "post",
      url: `${API_PDC_URL_V1}/session/start`,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        ...additionalHeaders
      },
      data: {
        customerId: companyId,
        accountantId: accountantId,
        startedBy: requester
      }
    };
    axios(request)
      .then((result) => {
        if (result.status === 200) {
          return true;
        }
        return false;
      })
      .catch((response) => {
        return { error: response };
      });
  };
}
